import { Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import ICheckbox from '../../components/checkbox/i-checkbox.component';
import SearchPanel from '../../components/search-panel/search-panel.component';
import IDropdown from '../../components/text-component/dropdown/i-dropdown.component';
import ITextField from '../../components/text-component/textfield/i-textfield.component';
import { ALL, INPUT_SELECT_ITEMS, LABOR_INPUT, TYPE_LABOR, TYPE_MATERIAL, TYPE_PROCESS } from '../common/constants';
import './master-data-list.component.scss';
import { LABOR_SPECS_MAP, MATERIAL_SPECS_MAP, PROCESS_SPECS_MAP } from './specs/specs.mapping';
import IButton from '../../components/button/i-button.component';
import IDialogComponent from '../../components/dialog/i-dialog.component';
import SpecParametersGrid from './spec-parameters.component-grid';
import { AppContext } from '../../app-context';
import { isEmpty, isNotEmpty, isNotEmptyArray, isChecking, isPacking } from '../common/util.services';
import { getMasterDataSpecs } from './masterdata.services';
import { FilterAltOutlined, FilterAltOffOutlined } from '@mui/icons-material';

type MasterDataSearchPanelProps = {
  search: any;
  searchData: any;
  costing: boolean;
  export?: any;
  showExportButton?: any;
}

const MasterDataSearchPanel = (props: MasterDataSearchPanelProps) => {
  const appContext = useContext(AppContext);
  const [isFilter, setIsFilter] = useState(false);
  const [inputList, setInputList] = useState<string[]>([]);
  const materialInputList: string[] = Object.keys(MATERIAL_SPECS_MAP).sort();
  const processInputList: string[] = Object.keys(PROCESS_SPECS_MAP).sort();
  const laborInputList: string[] = LABOR_INPUT.sort();
  const [open, setOpen] = useState(false);
  const [type, setType] = useState(ALL);
  const [input, setInput] = useState(ALL);
  const [specParams, setSpecParams] = useState<any>([]);
  const [specCount, setSpecCount] = useState(12);

  useEffect(() => {
    initializeSpecParams(input)
  }, [input])

  function initializeSpecParams(input: any) {
    if(isNotEmpty(input) && ALL !== input && ALL !== type) {
      let specsMap: { [key: string]: any };
      if (type === TYPE_MATERIAL) {
        specsMap = MATERIAL_SPECS_MAP;
      } else if (type === TYPE_PROCESS) {
        specsMap = PROCESS_SPECS_MAP;
      } else if (type === TYPE_LABOR) {
        specsMap = LABOR_SPECS_MAP;
      } else {
        specsMap = [];
      }

      if(TYPE_LABOR === type) {
        if(isChecking(input)) {
          input = 'Checking';
        } else if(isPacking(input)) {
          input = 'Packing';
        }
      }

      let rows: any = [];
      let count = 'Fabric' === input ? 15 : 12;
      setSpecCount(count);
      for(let i = 1; i <= count; ++i) {
        rows.push({id: i - 1, spec: specsMap[input][i - 1].fieldName, specValue: ALL, specValueList: []});
      }
      rows.push({id: count, spec: 'Supplier', specValue: ALL});

      setSpecParams(rows);
    }
  }

  const search = (searchData: any) => {
    searchData.latestOnly = searchData.isLatestOnly ? 1 : 0;
    searchData.specParams = specParams;
    props?.search(searchData);
  }

  const onTypeChange = (e: any) => {
    const type = e.target.value;
    updateInputType(type);
    setType(type);
    setInput(ALL);
    setIsFilter(false);
  }

  const onInputChange = (e: any) => {
    setInput(e.target.value);
    initializeSpecParams(e.target.value);
    setIsFilter(false);
  }

  const openSpecParams = () => {
    if(isEmpty(input) || ALL === input || ALL === type) {
      appContext.setDialogMessage('Select type and input.');
    } else {
      getMasterDataSpecs(input, appContext,
        (response: any) => {
          for(let i = 0; i <= specCount; ++i) {
            specParams[i].specValueList = response.data[i];
          }
          setOpen(true);
        }, (error: any) => {
          console.log(error);
        });
    }
  }

  const handleClose = (data: any) => {
    setOpen(false);
  }

  const close = (data: any) => {
    if(isNotEmptyArray(data)) {
      setSpecParams(data);
      for(let i = 0; i <= specCount; ++i) {
        if(ALL !== data[i].specValue) {
          setIsFilter(true);
          break;
        } else {
          setIsFilter(false);
        }
      }
    }
    setOpen(false);
  }

  const updateInputType = (type: any) => {
    if (type === TYPE_MATERIAL) {
      setInputList(materialInputList);
    } else if (type === TYPE_PROCESS) {
      setInputList(processInputList);
    } else if (type === TYPE_LABOR) {
      setInputList(laborInputList);
    } else {
      setInputList([]);
    }
  }

  return <SearchPanel search={search} formData={props.searchData} showExportBtn={props.showExportButton} export={props.export}>
    <Grid container spacing={0} alignItems="center" sx={{ justifyContent: 'center' }}>
      <Grid xs={2}>
        <ITextField name='searchText' label='Search Text' />
      </Grid>
      <Grid xs={2}>
        <IDropdown name='type' label='Type' itemList={INPUT_SELECT_ITEMS} allItemRequired={true}
          onChangeEvent={(e: any) => onTypeChange(e)} />
      </Grid>
      <Grid xs={2}>
        <IDropdown name='input' label='Input' itemList={inputList} allItemRequired={true} 
          onChangeEvent={(e: any) => onInputChange(e)} />
      </Grid>
      <Grid xs={2}>
        <IButton name='specParams' label='Advanced Filters' onActionEvent={openSpecParams} color='secondary' 
          btnIcon={isFilter ? <FilterAltOutlined /> : <FilterAltOffOutlined/>}/>
      </Grid>
      <Grid xs={2}>
        <ICheckbox name='isLatestOnly' label='Latest Cost Only' defaultChecked={props.costing}/>
      </Grid>
    </Grid>
    <IDialogComponent onClose={handleClose} open={open} title='Specify Specifications' 
      dialogBody={<SpecParametersGrid type={type} input={input} close={close} specParams={specParams}/>} />
  </SearchPanel>
}

export default MasterDataSearchPanel;